<template lang="pug">
  v-dialog(max-width='500px' v-model='mode.counterDialog' persistent scrollable transition='dialog-left-transition')
    v-card
      v-card-title.headline.grey.lighten-2.pa-1(primary-title) {{formTitle(&apos;Counter&apos;)}}
      v-card-text.pa-1
        v-form.pa-1(ref='counter')
          v-form-base#counterForm(:value='editedItem' :schema='schema' @input:counterForm='onFormInput')
            user-selector(slot='slot-item-key-_chefId' label='Chef In-charge' :context="{selectedId:editedItem._chefId, users:users.filter(u=>u.roles.includes('CC'))}" v-on:change='chefChanged($event)')
      v-divider
      v-card-actions
        v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.ACTIVE' :disabled='isDirty' text v-on:click.stop='deActivate(dialogKey)') De-Activate
        v-btn(color='primary' v-if='editedItem.id && editedItem.status === STATUSES.INACTIVE' :disabled='isDirty' text v-on:click.stop='editedItem.status=STATUSES.ACTIVE;save(dialogKey)') Activate
        v-spacer
        v-btn(color='primary' v-if='isDirty' text v-on:click.stop='cancel(dialogKey)') Cancel
        v-btn(color='primary' v-if='!isDirty' text v-on:click.stop='cancel(dialogKey)') Close
        v-btn(color='primary' :disabled='!isDirty' text v-on:click.stop='save(dialogKey)') Save

</template>

<script>
import { storeMixin } from "../../mixins/storeMixin.js";
import { dialogsMixin } from "../../mixins/dialogsMixin.js";

export default {
  name: "counter-dialog",
  mixins: [storeMixin, dialogsMixin],
  beforeMount() {
    if (!this.editedItem.id) {
      Object.assign(this.editedItem, this.defaultItem);
    }
  },
  data() {
    return {
      collectionName: "counters",
      dialogKey: "counterDialog",
      defaultItem: {
        name: "",
        status: 0,
        _chefId: null,
        chefName: "",
        notes: ""
      }
    };
  },
  computed: {
    schema() {
      return Object.assign(
        {
          _groupKey: { type: "text", hidden: true },
          _restaurantKey: { type: "text", hidden: true },
          code: {
            type: "text",
            label: "Code",
            flex: 2,
            sort: 1,
            rules: [
              this.required("Counter Code is required"),
              this.minLen(2),
              this.maxLen(8)
            ],
            disabled: true
          },
          name: {
            type: "text",
            label: "Name",
            flex: 9,
            offset: 1,
            sort: 2,
            rules: [
              this.required("Counter Name is required"),
              this.minLen(10),
              this.maxLen(40)
            ]
          },
          _chefId: {
            type: "text",
            sort: 3,
            flex: 12,
            hidden: !this.myFeatures.eligibleFeatures.includes("WORKFLOW")
          },
          chefName: { type: "text", sort: 5, flex: 12, hidden: true },
          status: {
            type: "select",
            label: "Status",
            items: ["Draft", "Open", "Closed", "Active", "Inactive"],
            flex: 3,
            sort: 4,
            rules: [this.required("Status is required")],
            hidden: true
          },
          notes: {
            type: "textarea",
            label: "Notes",
            flex: 12,
            sort: 5,
            rules: [this.maxLen(200)]
          }
        },
        this.baseSchema
      );
    }
  },
  methods: {
    chefChanged(user) {
      this.editedItem._chefId = user ? user.id : null;
      this.editedItem.chefName = user ? user.fullName : null;
      this.isDirty = true;
    }
  }
};
</script>